import { render, staticRenderFns } from "./BillingPlanFeatures.vue?vue&type=template&id=6ce4e0c2"
import script from "./BillingPlanFeatures.vue?vue&type=script&lang=js"
export * from "./BillingPlanFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports